import {
  FLOW_GUTTERS,
  FLOW_LAYOUT_STYLE,
  FLOW_OUTPUTS,
  FLOW_STEP_ACTIVATE,
  FLOW_STEP_CAPTURE,
  FLOW_STEP_UNDERSTAND,
  FLOW_TIMELINE_STYLE,
  outputArrivals,
} from "./ConceptFlow.logic";
import styles from "./ConceptFlow.module.css";
import ConceptFlowCallCard from "./components/ConceptFlowCallCard";
import ConceptFlowGutter from "./components/ConceptFlowGutter";
import ConceptFlowMemory from "./components/ConceptFlowMemory";
import ConceptFlowMessageCard from "./components/ConceptFlowMessageCard";
import ConceptFlowOutputCard from "./components/ConceptFlowOutputCard";
import ConceptFlowSources from "./components/ConceptFlowSources";
import ConceptFlowStepLabel from "./components/ConceptFlowStepLabel";

export default function ConceptFlow() {
  return (
    <div className={styles.panel} style={{ ...FLOW_TIMELINE_STYLE, ...FLOW_LAYOUT_STYLE }}>
      <div className={styles.stage}>
        {FLOW_GUTTERS.map((gutter) => (
          <ConceptFlowGutter gutter={gutter} key={gutter.id} />
        ))}

        <section className={styles.captureColumn}>
          <ConceptFlowStepLabel step={FLOW_STEP_CAPTURE} />
          <div className={`${styles.columnBody} ${styles.captureBody}`}>
            <ConceptFlowCallCard />
            <ConceptFlowMessageCard />
            <ConceptFlowSources />
          </div>
        </section>

        <section className={styles.memoryColumn}>
          <ConceptFlowStepLabel step={FLOW_STEP_UNDERSTAND} />
          <ConceptFlowMemory />
        </section>

        <section className={styles.activateColumn}>
          <ConceptFlowStepLabel step={FLOW_STEP_ACTIVATE} />
          <ul className={`${styles.columnBody} ${styles.outputs}`}>
            {FLOW_OUTPUTS.map((output, index) => (
              <ConceptFlowOutputCard
                key={output.titleKey}
                output={output}
                arrivals={outputArrivals(index)}
                outputIndex={index}
              />
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
